import { Component, ElementRef, Optional, Self } from '@angular/core';
import { NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldControl, MatFormField, MatLabel, MatSuffix, MatPrefix, MatError, MatHint } from '@angular/material/form-field';
import { MatBaseInputComponent } from '../mat-base-input.component';
import { MatFormFieldFix } from '../mat-form-field/mat-form-field-fix';
import { NgClass, NgIf } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-mat-text-input',
    providers: [{ provide: MatFormFieldControl, useExisting: MatTextInputComponent }],
    template: `
    <mat-form-field
      class="regular-form-field"
      [ngClass]="{ inline: inlineLabel }"
      [hintLabel]="hintLabel"
      [appearance]="appearance"
      (focusin)="onFocusIn($event)"
      (focusout)="onFocusOut($event)"
    >
      <mat-label *ngIf="!inlineLabel">
        {{ label }}
      </mat-label>
      <input
        matInput
        (keyup)="onKeyUp($event)"
        [formControl]="formControl"
        type="text"
        [id]="_id"
        [name]="name"
        [placeholder]="placeholder ? placeholder : inlineLabel ? label : ''"
        [autocomplete]="autocomplete"
        [readonly]="readonly"
        (input)="onChange($event.target['value'])"
      />
      <mat-icon *ngIf="!!explanation" matSuffix class="explanation" matTooltip="{{ explanation }}">
        {{ explanationIcon }}
      </mat-icon>
      <mat-icon *ngIf="prefixIcon" matPrefix>{{ prefixIcon }}</mat-icon>
      <mat-error *ngIf="formControl?.invalid">{{ firstError() }}</mat-error>
      <mat-hint align="start" *ngIf="!formControl?.invalid">{{ infoText }}</mat-hint>
    </mat-form-field>
  `,
    styles: ['.label-text {vertical-align: middle;}'],
    standalone: true,
    imports: [
        MatFormField,
        MatFormFieldFix,
        NgClass,
        NgIf,
        MatLabel,
        MatInput,
        FormsModule,
        ReactiveFormsModule,
        MatIcon,
        MatSuffix,
        MatTooltip,
        MatPrefix,
        MatError,
        MatHint,
    ],
})
export class MatTextInputComponent extends MatBaseInputComponent {
  constructor(
    @Optional() @Self() public ngControl: NgControl,
    public _elementRef: ElementRef<HTMLElement>,
  ) {
    super(ngControl, _elementRef);

    console.log(this.explanationIcon);
  }
}
